import React, { useState } from 'react';
import './TermsDelivery.scss';
import './TermsDelivery-media.scss';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import Button from '../Button/Button';
import { ISelectItem } from '../SelectsCity/interfaces';
import SelectsCity from '../SelectsCity/SelectsCity';
import { EnumUrlsPages } from '../../services/Enum';
import { Props } from './interfaces';
import {content} from "../../services/content";

const TermsDelivery = ({ widthWindow }: Props) => {
  const [valueFrom, setValueFrom] = useState<ISelectItem>(content.termsDeliveryBlock.optionsForm[0]);
  const [valueIn, setValueIn] = useState<ISelectItem>(content.termsDeliveryBlock.optionsIn[4]);

  const [From, setFrom] = useState<number>(0);
  const [In, setIn] = useState<number>(4);

  return (
    <div className="terms">
      <div className="terms__bg"></div>
      <SelectsCity
        optionsFrom={content.termsDeliveryBlock.optionsForm}
        optionsIn={content.termsDeliveryBlock.optionsIn}
        valueFrom={valueFrom}
        valueIn={valueIn}
        countsDays={content.termsDeliveryBlock.countDays}
        From={From}
        In={In}
        funcSelectFrom={(selectedOpt: any) => {
          setValueFrom(selectedOpt);
          setFrom(selectedOpt?.value);
        }}
        funcSelectIn={(selectedOpt: any) => {
          setValueIn(selectedOpt);
          setIn(selectedOpt?.value);
        }}
      />

      <div className="terms__price">
        {content.termsDeliveryBlock.priceTitle.map((count: string | number, i: number) => (
          <div className="terms__price-item" key={i}>
            <div>
              <h3>{widthWindow > 720 ? count : content.termsDeliveryBlock.priceTitle[3 - i]}</h3>
              <p className="body2">{content.termsDeliveryBlock.textCountPerMonth}</p>
            </div>

            <div>
              <h4>{`${content.termsDeliveryBlock.priceFromIn[From][In][widthWindow > 720 ? i : 3 - i]} р`}</h4>
              <p className="body2">{content.termsDeliveryBlock.textAverageCost}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="terms__buttons">
        <Button
          text="Калькулятор"
          link={EnumUrlsPages.calculator}
          type="border"
          size="L"
          widthAll={widthWindow < 720}
        />
        <Button text="Все тарифы" link={EnumUrlsPages.calculator} size="L" widthAll={widthWindow < 720} />
      </div>
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(TermsDelivery));
